import { createContext, useContext, useEffect, useState } from "react";

const YearContext = createContext();

export const AVAILABLE_YEARS = ["2026", "2025"];
const DEFAULT_YEAR = "2026";

let currentSelectedYear = DEFAULT_YEAR;

export const getSelectedYear = () => currentSelectedYear;

export const YearProvider = ({ children }) => {
  const [year, setYearState] = useState(DEFAULT_YEAR);

  const setYear = (newYear) => {
    const normalized = String(newYear);
    currentSelectedYear = normalized;
    setYearState(normalized);
  };

  // 연도별 디자인 색 (global.css의 :root[data-year])
  useEffect(() => {
    document.documentElement.dataset.year = year;
  }, [year]);

  return (
    <YearContext.Provider value={{ year, setYear, years: AVAILABLE_YEARS }}>
      {children}
    </YearContext.Provider>
  );
};

export const useYear = () => {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error("useYear must be used within a YearProvider");
  }
  return context;
};

